import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn("animate-pulse rounded-[8px] bg-surface-inset", className)}
      {...props} />
  );
}

export { Skeleton }
